function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import Vue from 'vue';
import { isVNode, isFunction, isNumber, isPlainObject } from '@cloud-sn/v-utils';
import Notification from '@cloud-sn/v-notification';
import Icon from '../icon';
var defaultProps = {
  prefixCls: 'ux-notification',
  placement: 'topRight',
  // ms
  duration: 4500,
  top: 24,
  bottom: 24,
  getContainer: null,
  theme: 'light'
};
var iconTypes = {
  // success: 'ok_circle_o',
  // info: 'info_circle_o',
  // warn: 'exclamation_circle_o',
  // warning: 'exclamation_circle_o',
  // error: 'close_circle_o',
  success: 'ok_circle',
  info: 'info_circle',
  warn: 'exclamation_circle',
  warning: 'exclamation_circle',
  error: 'close_circle'
};

var customProps = _objectSpread({}, defaultProps);

var notificationInst = {};
var seed = 0;

function getPlacementStyle(placement) {
  var _customProps = customProps,
      top = _customProps.top,
      bottom = _customProps.bottom;
  return {
    topLeft: {
      top: "".concat(top, "px"),
      left: 0
    },
    bottomLeft: {
      left: 0,
      bottom: "".concat(bottom, "px")
    },
    bottomRight: {
      right: 0,
      bottom: "".concat(bottom, "px")
    }
  }[placement] || {
    top: "".concat(top, "px"),
    right: 0
  };
}

function getNotificationInstance(pCls, cPlacement) {
  var _customProps2 = customProps,
      defaultPrefixCls = _customProps2.prefixCls,
      defaultPlacement = _customProps2.placement,
      theme = _customProps2.theme,
      getContainer = _customProps2.getContainer;
  var prefixCls = pCls || defaultPrefixCls;
  var placement = cPlacement || defaultPlacement;
  var key = "".concat(prefixCls, "-").concat(placement);

  if (!notificationInst[key]) {
    notificationInst[key] = Notification.newInstance({
      prefixCls: prefixCls,
      notificationClass: ["".concat(prefixCls, "-").concat(theme), key],
      notificationStyle: getPlacementStyle(placement),
      getContainer: getContainer
    });
  }

  return notificationInst[key];
}

function notice(_ref) {
  var pCls = _ref.prefixCls,
      className = _ref.className,
      style = _ref.style,
      placement = _ref.placement,
      title = _ref.title,
      description = _ref.description,
      _ref$dangerouslySetIn = _ref.dangerouslySetInnerHTML,
      dangerouslySetInnerHTML = _ref$dangerouslySetIn === void 0 ? false : _ref$dangerouslySetIn,
      btn = _ref.btn,
      icon = _ref.icon,
      _ref$duration = _ref.duration,
      duration = _ref$duration === void 0 ? customProps.duration : _ref$duration,
      onClose = _ref.onClose,
      _ref$closable = _ref.closable,
      closable = _ref$closable === void 0 ? true : _ref$closable,
      others = _objectWithoutProperties(_ref, ["prefixCls", "className", "style", "placement", "title", "description", "dangerouslySetInnerHTML", "btn", "icon", "duration", "onClose", "closable"]);

  // eslint-disable-next-line
  var h = this.$createElement;
  var prefixCls = "".concat(pCls || customProps.prefixCls, "-notice");
  var iconElement = null;

  if (typeof icon === 'string' || isVNode(icon) || isPlainObject(icon)) {
    if (isVNode(icon)) {
      iconElement = h("span", {
        "class": "".concat(prefixCls, "-icon")
      }, [icon]);
    } else {
      var iconType = {
        type: '',
        style: {}
      };

      if (typeof icon === 'string') {
        iconType.type = icon;
      } else {
        // plain object
        iconType = _objectSpread({}, iconType, {}, icon);
      }

      iconElement = h(Icon, {
        "attrs": {
          "type": iconType.type in iconTypes ? iconTypes[iconType.type] : iconType.type
        },
        "class": ["".concat(prefixCls, "-icon"), "".concat(prefixCls, "-icon-").concat(iconType.type)],
        "style": iconType.style
      });
    }
  }

  var contentElement = h("div", {
    "class": iconElement ? "".concat(prefixCls, "-with-icon") : ''
  }, [iconElement, h("div", {
    "class": "".concat(prefixCls, "-message")
  }, [title]), dangerouslySetInnerHTML ? h("div", {
    "class": "".concat(prefixCls, "-description"),
    "domProps": {
      "innerHTML": description
    }
  }) : h("div", {
    "class": "".concat(prefixCls, "-description")
  }, [description]), btn ? h("span", {
    "class": "".concat(prefixCls, "-btn")
  }, [btn]) : null]);
  var instance = getNotificationInstance(pCls, placement);
  var props = {
    $$id: "$$id-".concat(seed += 1),
    props: _objectSpread({}, others, {
      content: contentElement,
      duration: duration,
      closable: closable
    }),
    className: className,
    style: style,
    onClose: onClose
  };
  instance.notice(props);
  return function () {
    instance.remove(props);
  };
}

function destroy() {
  Object.keys(notificationInst).forEach(function (key) {
    var inst = notificationInst[key];

    if (inst) {
      inst.destroy();
    }
  });
  notificationInst = {};
}

function setNotificationConfig(_ref2) {
  var prefixCls = _ref2.prefixCls,
      placement = _ref2.placement,
      duration = _ref2.duration,
      top = _ref2.top,
      bottom = _ref2.bottom,
      getContainer = _ref2.getContainer,
      theme = _ref2.theme;

  if (prefixCls || isNumber(top) || isNumber(bottom) || isFunction(getContainer) || theme) {
    destroy();
  }

  var props = {};

  if (prefixCls) {
    props.prefixCls = prefixCls;
  }

  if (isNumber(top)) {
    props.top = top;
  }

  if (isNumber(bottom)) {
    props.bottom = bottom;
  }

  if (isFunction(getContainer)) {
    props.getContainer = getContainer;
  }

  if (placement) {
    props.placement = placement;
  }

  if (typeof duration === 'number') {
    props.duration = duration;
  }

  if (theme) {
    props.theme = theme;
  }

  customProps = _objectSpread({}, defaultProps, {}, props);
}

var openFn = notice.bind(new Vue());
var notificationInfo = {
  open: openFn,
  config: setNotificationConfig,
  destroy: destroy
}; // success , warn, warning, error, info

Object.keys(iconTypes).forEach(function (k) {
  notificationInfo[k] = function (args) {
    openFn(_objectSpread({}, args, {
      icon: k
    }));
  };
});
export default notificationInfo;